export const ru = {
    auto: 'Авто',
    'bid-auto-strategy-info':
        'Ставка рассчитана исходя из условий автоматической стратегии. В процессе работы автоматических стратегий управления ставками система самостоятельно контролирует размещение.'
};
